"use client";
import { MadsBox, MadsButton, MadsText } from "@mads/ui-react";
import { useSignIn } from "../hooks/useSignIn";
import dataQaIds from "@/constants/dataQaIds";

const SignInWrapper = () => {
  const {
    signInLoading,
    pageContent,
    welcomeMProxyUrl,
    handleJoinFree,
    handleSignIn,
  } = useSignIn();

  if (!pageContent) return null;

  const {
    welcomeHeading,
    corpHeading,
    corpSubHeading,
    corpParagraph,
    notAMember,
    joinForFreeNow,
    signInBtn,
  } = pageContent;

  const qa = dataQaIds.welcomePage;
  return (
    <MadsBox
      w="100%"
      h="100vh"
      px="layout-lg"
      py="layout-xl"
      flex
      direction="column"
      justify="flex-end"
      gap="layout-sm"
      className="mFill-logo"
      style={
        {
          "--bg-url": `url(${welcomeMProxyUrl})`,
        } as React.CSSProperties
      }
    >
      <MadsText typography="eyebrow-md" data-testid={qa.lastnameLabelId}>
        {welcomeHeading}
      </MadsText>
      <MadsText
        data-testid={qa.headingId}
        typography="display-xl"
        w="lg:60% 100%"
      >
        {corpHeading}
      </MadsText>
      <MadsText typography="body-xl-bold" data-testid={qa.subHeadingId}>
        {corpSubHeading}
      </MadsText>
      <MadsText
        typography="body-lg-regular"
        data-testid={qa.contentId}
        w="lg:40% 100%"
      >
        {corpParagraph}
      </MadsText>
      <MadsButton
        size="md"
        onClick={handleSignIn}
        data-testid={qa.signInBtnId}
        fullWidth="true md:false"
        disabled={signInLoading}
      >
        {signInBtn}
      </MadsButton>
      <MadsBox flex direction="lg:row xs:column" gap="sm" align="center">
        <MadsText
          typography="body-sm-medium"
          data-testid={qa.notAMemberLabelId}
        >
          {notAMember}
        </MadsText>

        <MadsButton
          variant="tertiary"
          icon-end="swivel-out"
          fullWidth="true md:false"
          onClick={handleJoinFree}
          data-testid={qa.joinForFreeBtnId}
        >
          {joinForFreeNow}
        </MadsButton>
      </MadsBox>
    </MadsBox>
  );
};

export default SignInWrapper;
